(() => {
  const TRANS_MS = 800;
  let rafScheduled = false;

  // Helper to set final collapsed state
  const setCollapsed = (el) => {
    el.style.height = "0px";
    el.style.opacity = "0";
    el.style.pointerEvents = "none";
    el.style.transition = "none"; // Reset transition
    el.dataset.rcState = "collapsed";
  };

  // Helper to set final expanded state
  const setExpanded = (el) => {
    el.style.height = "auto";
    el.style.opacity = "1";
    el.style.pointerEvents = "auto";
    el.style.transition = "none"; // Reset transition so resizing window works naturally
    el.dataset.rcState = "expanded";
  };

  const collapseSmooth = (el) => {
    if (!el) return;
    if (el.dataset.rcState === "collapsed" || el.dataset.rcState === "collapsing") return;

    el.dataset.rcState = "collapsing";

    // 1. Get the exact current height (scrollHeight is often more accurate for content)
    const height = el.scrollHeight;

    // 2. CRITICAL STEP: Disable transition temporarily to snap from 'auto' to pixels
    el.style.transition = "none";
    el.style.height = `${height}px`;
    el.style.opacity = "1";
    el.style.pointerEvents = "none";

    // 3. Force browser to paint this state
    el.getBoundingClientRect();

    // 4. Double requestAnimationFrame to ensure the 'start' frame is registered
    requestAnimationFrame(() => {
      // Re-enable transition for the animation
      el.style.transition = `height ${TRANS_MS}ms ease, opacity ${TRANS_MS}ms ease`;
      
      requestAnimationFrame(() => {
        el.style.height = "0px";
        el.style.opacity = "0";
      });
    });

    // Cleanup after animation finishes
    const onEnd = (e) => {
      if (e.propertyName !== "height") return;
      el.removeEventListener("transitionend", onEnd);
      setCollapsed(el);
    };

    el.addEventListener("transitionend", onEnd);
    
    // Safety fallback
    setTimeout(() => {
      if (el.dataset.rcState === "collapsing") setCollapsed(el);
    }, TRANS_MS + 50);
  };

  const expandSmooth = (el) => {
    if (!el) return;
    if (el.dataset.rcState === "expanded" || el.dataset.rcState === "expanding") return;

    el.dataset.rcState = "expanding";
    el.style.pointerEvents = "auto";

    // 1. Ensure we start from 0
    el.style.transition = "none";
    el.style.height = "0px";
    el.style.opacity = "0";
    
    // 2. Calculate target
    // Temporarily unleash height to measure it, then snap back
    // (Note: usually scrollHeight works on the 0px element if overflow is hidden correctly)
    const targetHeight = el.scrollHeight; 

    el.getBoundingClientRect(); // Force reflow

    // 3. Animate
    requestAnimationFrame(() => {
      el.style.transition = `height ${TRANS_MS}ms ease, opacity ${TRANS_MS}ms ease`;
      
      requestAnimationFrame(() => {
        el.style.height = `${targetHeight}px`;
        el.style.opacity = "1";
      });
    });

    const onEnd = (e) => {
      if (e.propertyName !== "height") return;
      el.removeEventListener("transitionend", onEnd);
      setExpanded(el);
    };

    el.addEventListener("transitionend", onEnd);
    
    // Safety fallback
    setTimeout(() => {
        if (el.dataset.rcState === "expanding") setExpanded(el);
    }, TRANS_MS + 50);
  };

  const updateAccordion = (root) => {
    const options = [...root.querySelectorAll(".rc-purchase-option")];

    options.forEach((option) => {
      const sub = option.querySelector(".rc-purchase-option__sub-container");
      if (!sub) return;

      const isSelected =
        option.hasAttribute("rc-selected") ||
        option.classList.contains("rc-purchase-option__selected") ||
        option.classList.contains("rc-selection__selected");

      if (isSelected) {
        expandSmooth(sub);
      } else {
        collapseSmooth(sub);
      }
    });
  };

  const scheduleUpdate = (root) => {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(() => {
      rafScheduled = false;
      updateAccordion(root);
    });
  };

  const initWidget = (widget) => {
    if (!widget?.shadowRoot || widget.__smoothAccordionInit) return;
    widget.__smoothAccordionInit = true;

    const root = widget.shadowRoot;

    // CSS: We still keep the transition rule here as a baseline, 
    // but the JS will manually toggle it to handle the 'auto' height issue.
    const style = document.createElement("style");
    style.textContent = `
      .rc-purchase-option__sub-container {
        display: block !important;
        overflow: hidden;
        will-change: height, opacity;
      }
      @media (prefers-reduced-motion: reduce) {
        .rc-purchase-option__sub-container {
          transition: none !important;
        }
      }
    `;
    root.appendChild(style);

    // Initial Setup
    root.querySelectorAll(".rc-purchase-option__sub-container").forEach(setCollapsed);
    setTimeout(() => scheduleUpdate(root), 100);

    // Events
    root.addEventListener("click", () => setTimeout(() => scheduleUpdate(root), 50));
    
    const mo = new MutationObserver(() => scheduleUpdate(root));
    mo.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["rc-selected", "class"],
    });
  };

  const scan = () => {
    document.querySelectorAll("recharge-subscription-widget").forEach(initWidget);
  };

  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();